import { NoPreloading } from '@angular/router';

export const environment = {
    production: true,
    preloadStrategy: NoPreloading,
    buildVersion: '1.3.231',
    staticHost: 'https://static.pstg-prd.net/3rdparty-assets',
};
